import { useEffect, useState } from "react";
import { match } from "ts-pattern";
import { SelectWallet } from "./select-wallet";
import { Failed } from "./failed";
import { ConnectWallet } from "./types";
import { WalletKey, WalletOption } from "@silo/types";

interface DisconnectedFlowProps {
  connectWallet: ConnectWallet;
  walletOptions: WalletOption[];
}

type DisconnectedState =
  | { _tag: "selecting" }
  | { _tag: "failed"; errorMessage?: string; walletKey: WalletKey };

export function DisconnectedFlow({
  connectWallet,
  walletOptions,
}: DisconnectedFlowProps): JSX.Element {
  const [state, setState] = useState<DisconnectedState>({ _tag: "selecting" });
  const [isPending, setIsPending] = useState(false);

  function selectWallet(walletKey: WalletKey): void {
    async function fn() {
      try {
        setIsPending(true);

        await connectWallet(walletKey);
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : undefined;

        setState({ _tag: "failed", errorMessage, walletKey });
      } finally {
        setIsPending(false);
      }
    }

    fn();
  }

  function goBack(): void {
    setState({ _tag: "selecting" });
  }

  return match(state)
    .with({ _tag: "selecting" }, () => (
      <SelectWallet
        walletOptions={walletOptions}
        isPending={isPending}
        activeWalletKey={null}
        selectWallet={selectWallet}
      />
    ))
    .with({ _tag: "failed" }, ({ errorMessage, walletKey }) => (
      <Failed
        errorMessage={errorMessage}
        walletKey={walletKey}
        selectWallet={selectWallet}
        isPending={isPending}
        goBack={goBack}
      />
    ))
    .exhaustive();
}
